import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class UsersApi {
  static getFacilityUsers = (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();

    return axios.get(
      API_BASE_URL +
        '/allFacilityUsers/' +
        (filters.facilityId === '' ? 'all' : filters.facilityId) +
        '?' +
        queryParams,
    );
  };

  static getFacilityUserInformation = (userId) => {
    return axios.get(API_BASE_URL + '/getFacilityUserInformation/' + userId);
  };

  static getFacilityUser = (userId) => {
    return axios.get(`${API_BASE_URL}/users/facility/${userId}`);
  };

  static getFacilityUserHistory = (userId, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return axios.get(
      `${API_BASE_URL}/users/facility/${userId}/history?${queryParams}`,
    );
  };

  static updateFacilityUser = (userId, data) => {
    return axios.put(`${API_BASE_URL}/facility-users/${userId}`, data);
  };

  static createFacilityUser = (data) => {
    return axios.post(`${API_BASE_URL}/facility-users`, data);
  };

  static updateFacilityUserScope = (facilityUserId, data) => {
    return axios.put(
      `${API_BASE_URL}/users/facility/${facilityUserId}/scope`,
      data,
    );
  };

  static getFacilityUserEmails = (filters = {}) => {
    const queryParams = new URLSearchParams();

    if (filters.organization_id) {
      queryParams.append('organization_id', filters.organization_id);
    }
    if (filters.facility_id) {
      queryParams.append('facility_id', filters.facility_id);
    }

    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/users/facility-emails${
      queryString ? `?${queryString}` : ''
    }`;

    return axios.get(url);
  };

  static getUserPermissions = (userId, params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.facility_id) {
      queryParams.append('facility_id', params.facility_id);
    }
    if (params.organization_id) {
      queryParams.append('organization_id', params.organization_id);
    }
    if (params.permission_type) {
      queryParams.append('permission_type', params.permission_type);
    }

    const queryString = queryParams.toString();
    return axios.get(
      `${API_BASE_URL}/users/facility/${userId}/permissions?${queryString}`,
    );
  };

  static getUsers = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.organization_id) {
      queryParams.append('organization_id', params.organization_id);
    }
    if (params.facility_id) {
      queryParams.append('facility_id', params.facility_id);
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }
    if (params.status !== undefined) {
      queryParams.append('status', params.status);
    }
    if (params.role_id) {
      queryParams.append('role_id', params.role_id);
    }
    if (params.page) {
      queryParams.append('page', params.page);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit);
    }
    if (params.sortBy) {
      queryParams.append('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }

    const queryString = queryParams.toString();
    return axios.get(
      `${API_BASE_URL}/users/facility${queryString ? `?${queryString}` : ''}`,
    );
  };

  static changeFacilityUserRole = (facilityUserId, roleId) => {
    return axios.post(
      `${API_BASE_URL}/facility-users/${facilityUserId}/change-role`,
      {
        facility_user_id: facilityUserId,
        role_id: roleId,
      },
    );
  };

  static enableFacilityUser = (facilityUserId) => {
    return axios.post(
      `${API_BASE_URL}/facility-users/${facilityUserId}/enable`,
      {
        facility_user_id: facilityUserId,
      },
    );
  };

  static disableFacilityUser = (facilityUserId) => {
    return axios.post(
      `${API_BASE_URL}/facility-users/${facilityUserId}/disable`,
      {
        facility_user_id: facilityUserId,
      },
    );
  };

  static assignUserFacilities = (
    facilityUserId,
    { facilityIds, allFacilities },
  ) => {
    const payload = allFacilities
      ? { all_facilities: true }
      : { facility_ids: facilityIds };

    return axios.post(
      `${API_BASE_URL}/facility-users/${facilityUserId}/assign-facilities`,
      payload,
    );
  };

  static exportFacilityUsers = (filters = {}) => {
    const queryParams = new URLSearchParams();

    if (filters.organization_id) {
      queryParams.append('organization_id', filters.organization_id);
    }
    if (filters.facility_id) {
      queryParams.append('facility_id', filters.facility_id);
    }
    if (filters.facility_group_id) {
      queryParams.append('facility_group_id', filters.facility_group_id);
    }
    if (filters.status !== undefined) {
      queryParams.append('status', filters.status);
    }
    if (filters.search) {
      queryParams.append('search', filters.search);
    }

    const queryString = queryParams.toString();
    return axios.get(
      `${API_BASE_URL}/users/facility/export${
        queryString ? `?${queryString}` : ''
      }`,
      { responseType: 'blob' },
    );
  };

  static activateUser = (encodedUser) => {
    return axios.get(`${API_BASE_URL}/users/activation/${encodedUser}`);
  };

  static updatePassword = (formData) => {
    return axios.post(`${API_BASE_URL}/users/update_password`, formData);
  };

  static getOtpQrCode = () => {
    return axios.get(`${API_BASE_URL}/users/otp_qrcode`);
  };

  static verifyOTP = (formData) => {
    return axios.post(`${API_BASE_URL}/users/verify_otp`, formData);
  };

  static resetPassword = (formData) => {
    return axios.post(`${API_BASE_URL}/users/reset_password`, formData);
  };
}
